import { useScopedTranslation } from 'application/localization/useScopedTranslation.ts';
import styles from './GenerateDescriptionHeader.module.scss';
import {
  TextButton,
  TextButtonColor,
} from 'components/uikit/buttons/TextButton.tsx';
import EditIcon from 'assets/icons/edit.svg?react';
import CloseIcon from 'assets/icons/close-button.svg?react';
import { Trans } from 'react-i18next';
import { useProjectContext } from '../../../projectPermissions/ProjectContext.tsx';
import { FeatureFlags } from 'application/constants/env-variables.ts';

type GenerateDescriptionHeaderProps = {
  onClose: () => void;
};

export const GenerateDescriptionHeader = (
  props: GenerateDescriptionHeaderProps,
) => {
  const i18n = useScopedTranslation('Component.GenerateDescriptionChat');

  const projectContext = useProjectContext();

  return (
    <div className={styles.header}>
      <div className={styles.leftSide}>
        <div className={styles.title}>{i18n.t('title')}</div>
        <div className={styles.editProjectElements}>
          <Trans
            i18nKey={'Component.GenerateDescriptionChat.project_context'}
            values={{
              projectName: projectContext.project?.name,
            }}
            components={{
              grey: <span className={styles.grey} />,
            }}
          />
          {FeatureFlags.aiChatEnabled() && (
            <TextButton
              icon={<EditIcon />}
              color={TextButtonColor.GreyPlain}
              className={styles.editProjectButton}
            />
          )}
        </div>
      </div>
      <TextButton
        icon={<CloseIcon />}
        color={TextButtonColor.GreyPlain}
        className={styles.closeButton}
        onClick={props.onClose}
      />
    </div>
  );
};
